/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendTaxPrmDto } from '../../models/backend-tax-prm-dto';
import { BackendTaxPrmRequestDto } from '../../models/backend-tax-prm-request-dto';

export interface ProjectTaxesTaxPrmsCopyCreate$Params {
  id: string;
  body: BackendTaxPrmRequestDto;
}

export function projectTaxesTaxPrmsCopyCreate(
  http: HttpClient,
  rootUrl: string,
  params: ProjectTaxesTaxPrmsCopyCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendTaxPrmDto>> {
  const rb = new RequestBuilder(rootUrl, projectTaxesTaxPrmsCopyCreate.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendTaxPrmDto>;
    }),
  );
}

projectTaxesTaxPrmsCopyCreate.PATH = '/api/project_taxes/tax_prms/copy/{id}/';
